// Application constants
export const CONSTANTS = {
  // Local Storage Keys
  SETTINGS_SECTION_KEY: 'listWizSettingsSection',
  
  // Default Section Names
  DEFAULT_SECTION: 'profile',
  
  // Modal Types
  MODAL_TYPES: {
    ALERT: 'alert',
    CONFIRM: 'confirm'
  },
  
  // Section Names
  SECTIONS: {
    PROFILE: 'profile',
    CATEGORIES: 'categories', 
    ADMIN: 'admin',
    NOTIFICATIONS: 'notifications',
    DATA: 'data'
  },
  
  // Data Types
  DATA_TYPES: {
    STRING: 'string'
  },
  
  // Property Names
  PROPERTIES: {
    IS_ADMIN: 'isAdmin'
  },
  
  // Error Messages
  ERROR_PATTERNS: {
    FETCH: 'fetch'
  }
};
